var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "black",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0228 10.9551H15.9773C13.1646 10.9551 10.9546 13.1651 10.9546 15.9778V26.0233C10.9546 28.836 13.1646 31.046 15.9773 31.046H26.0228C28.8355 31.046 31.0455 28.836 31.0455 26.0233V15.9778C31.0455 13.1651 28.8355 10.9551 26.0228 10.9551ZM29.0364 26.0233C29.0364 27.731 27.7305 29.0369 26.0228 29.0369H15.9773C14.2696 29.0369 12.9637 27.731 12.9637 26.0233V15.9778C12.9637 14.2701 14.2696 12.9642 15.9773 12.9642H26.0228C27.7305 12.9642 29.0364 14.2701 29.0364 15.9778V26.0233Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 15.9785C18.1871 15.9785 15.9771 18.1885 15.9771 21.0012C15.9771 23.814 18.1871 26.024 20.9998 26.024C23.8125 26.024 26.0225 23.814 26.0225 21.0012C26.0225 18.1885 23.8125 15.9785 20.9998 15.9785ZM20.9998 24.0149C19.2921 24.0149 17.9861 22.709 17.9861 21.0012C17.9861 19.2935 19.2921 17.9876 20.9998 17.9876C22.7075 17.9876 24.0134 19.2935 24.0134 21.0012C24.0134 22.709 22.7075 24.0149 20.9998 24.0149Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0221 16.9817C26.5769 16.9817 27.0267 16.532 27.0267 15.9772C27.0267 15.4224 26.5769 14.9727 26.0221 14.9727C25.4673 14.9727 25.0176 15.4224 25.0176 15.9772C25.0176 16.532 25.4673 16.9817 26.0221 16.9817Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.7ad296d0e08fbb0f07ee260bd5e31c5b.svg";
export { ForwardRef as ReactComponent };